import { Box, CircularProgress, type SxProps } from '@mui/material';
import { type ReactElement } from 'react';

interface CircularProgressIconProps {
  icon: ReactElement;
  progress: number;
  active?: boolean;
  size?: number;
  sx?: SxProps;
  color?: string;
}

export function CircularProgressIcon({
  icon,
  progress,
  active = true,
  size = 35,
  sx,
  color = 'primary.main',
}: CircularProgressIconProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: size,
        height: size,
        display: 'inline-flex',
        ...sx,
      }}
    >
      <CircularProgress
        variant="determinate"
        value={active ? progress : 0}
        size={size}
        sx={{
          position: 'absolute',
          color,
          opacity: active ? 1 : 0.3,
          transition: 'all 0.3s ease-in-out',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </Box>
    </Box>
  );
}
